/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

import { IFrame } from 'Components/atoms/IFrame';

/**
 * CarwowValuationWidget component
 * @param {string} impactUrl - Impact URL used for tracking, site specific
 * @returns {JSX.Element}
 */
const CarwowValuationWidget = ({
  impactUrl,
}) => {
  const settings = btoa(JSON.stringify({
    theme: 'carwow',
  }));

  return (
    <div className="polaris__carwow-valuation-widget">
      <IFrame
        iframeUrl={`//quotes.carwow.co.uk/widgets/sell-my-car?impact_url=${impactUrl}&settings=${settings}&vrm=&mileage=`}
        iframeWidth="100%"
        iframeHeight="450px"
        iframeStyle={{ border: '0px none transparent' }}
      />
    </div>
  );
};

CarwowValuationWidget.propTypes = {
  impactUrl: PropTypes.string.isRequired,
};

export default CarwowValuationWidget;
